import { countryFlag, healthMeta, formatLatency, formatTime } from '../lib/format.js';

export default function NodePanel({ nodes, onRefresh, busy }) {
  return (
    <div className="card">
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
        <div>
          <h2 className="card__title">Exit nodes</h2>
          <p className="card__hint" style={{ marginBottom: 0 }}>
            Your own VPS servers. Each probe confirms the node is reachable and that its IP really
            geolocates to the declared country.
          </p>
        </div>
        <button className="btn btn--ghost btn--sm" onClick={onRefresh} disabled={busy}>
          {busy ? 'Probing…' : 'Probe all'}
        </button>
      </div>

      <div style={{ height: 16 }} />

      {nodes.length === 0 ? (
        <div className="empty">
          No exit nodes configured yet.
          <br />
          Copy <code>server/nodes.example.json</code> to <code>server/nodes.json</code> and add your
          VPS details.
        </div>
      ) : (
        <div className="nodes">
          {nodes.map((node) => {
            const meta = healthMeta[node.health.status] ?? healthMeta.unknown;
            return (
              <div className="node" key={node.id}>
                <span className="node__flag">{countryFlag(node.country)}</span>
                <div>
                  <div className="node__label">{node.label}</div>
                  <div className="node__meta">
                    {node.protocol} · {node.id}
                    {node.health.exitIp ? ` · exit IP ${node.health.exitIp}` : ''}
                    {node.health.exitCountry && node.health.exitCountry !== node.country
                      ? ` · geolocates to ${node.health.exitCountry}`
                      : ''}
                  </div>
                  {node.health.lastError && (
                    <div className="node__meta" style={{ color: 'var(--warn)' }}>
                      {node.health.lastError}
                    </div>
                  )}
                </div>
                <div className="node__right">
                  <span className="node__meta">{formatLatency(node.health.latencyMs)}</span>
                  <span className="node__meta">{formatTime(node.health.lastCheckedAt)}</span>
                  <span className={`badge badge--${meta.tone}`}>
                    <span className={`dot dot--${meta.tone}`} />
                    {meta.label}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
